import React, { useEffect, useState } from 'react';
import { Card, Button, Spinner } from 'react-bootstrap';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import FancyPLTableEventPl from 'Common/Tables/eventPlTables/EventPl';
import { authServices } from 'Utils/auth/services';

interface FancyPLData {
    sport_name: string;
    uplineProfitLoss: number;
    total: number;
    commission: number;
    type: number;
    sport_id: string;
}

const EventPl: React.FC = () => {
    const [startDate, setStartDate] = useState<Date | null>(new Date());
    const [endDate, setEndDate] = useState<Date | null>(new Date());
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [casinoBetsData, setCasinoBetsData] = useState<FancyPLData[]>([]);

    // Fetch the casino bets list
    const get = async () => {
        setIsLoading(true);
        try {
            const payload = {
                from_date: startDate?.toISOString(),
                to_date: endDate?.toISOString(),
            };
            const { response } = await authServices.getEventPl(payload);

            if (response?.data) {
                setCasinoBetsData(response.data);
            } else {
                setCasinoBetsData([]);
            }
        } catch (error) {
            console.error("Error fetching casino bets data:", error);
            setCasinoBetsData([]);
        } finally {
            setIsLoading(false);
        }
    };

    // Call API on page load
    useEffect(() => {
        get();
    }, []);

    // Handle row click and navigate
    const handleRowClick = (sport_id: string, sport_name: string, type: number) => {
        const from_date = startDate?.toISOString();
        const to_date = endDate?.toISOString();
        const url = `/plMatchwise/${sport_id}/${sport_name}/${from_date}/${to_date}/${type}`;
        // navigate(url);
        window.open(url, "_blank");
        
    };

    return (
        <div className="event-pl">
            {/* <h4>Event P/L</h4> */}
            <Card className="event-pl-card mb-3">
                <Card.Body>
                    <Card.Header className="event-pl-header">
                        <div className="date-filter d-flex gap-2 align-items-center">
                            <Flatpickr
                                className="form-control"
                                options={{
                                    enableTime: true,
                                    dateFormat: "Y-m-d H:i:s",
                                }}
                                value={startDate ? startDate.toISOString() : ''}
                                onChange={([date]: Date[]) => setStartDate(date)}
                            />
                            <Flatpickr
                                className="form-control"
                                options={{
                                    enableTime: true,
                                    dateFormat: "Y-m-d H:i:s",
                                }}
                                value={endDate ? endDate.toISOString() : ''}
                                onChange={([date]: Date[]) => setEndDate(date)}
                            />
                            <Button
                                variant="success"
                                className="submit-btn"
                                onClick={get}
                            >
                                Filter
                            </Button>
                        </div>
                    </Card.Header>
                </Card.Body>
            </Card>

            <Card>
                <Card.Body>
                    {isLoading ? (
                        <div className="text-center">
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>
                        </div>
                    ) : (
                        <FancyPLTableEventPl fancyPLData={casinoBetsData} onRowClick={handleRowClick} />
                    )}
                </Card.Body>
            </Card>
        </div>
    );
};

export default EventPl;
